import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  name: String;
  now: Date;
  isAuthenticated: boolean = false;
  obtainingPermissions: boolean = false;
  errorObtainingPermissions: boolean = false;

  constructor(
    public user: UserService,
    public router: Router,
  ) {
    user.isAuthenticated.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
    });
    user.obtainingPermissions.subscribe(val => {
      this.obtainingPermissions = val;
    });
    user.userName.subscribe(value => {
      this.name = value;
    });
    user.errorObtainingPermissions.subscribe(value => {
      this.errorObtainingPermissions = value;
    });
  }

  async ngOnInit() {
    this.now = new Date();
  }
}
